import { useQuery } from '@tanstack/react-query'
import ErrorOutline from '@mui/icons-material/ErrorOutline'
import { QueryOptions } from 'models/general'
import {IInvoice,  PaymentComplement } from 'models/invoices.models'
import { selectErrorDialog } from 'lib/helpers/errors.helpers'
import useDialog from 'hooks/Shared/useDialog'
import { getPaymentComplementList } from 'services/Invoices/invoices.services'
import { TModalIcon } from 'components/Shared/SydDialog/SydDialog'

const usePaymentComplementList = (
  workspaceId: number,
  invoice?: IInvoice,
  options: QueryOptions<PaymentComplement[]> = {}
) => {
  // const dispatch = useDispatch();
  const dialog = useDialog()

  const {
    onBefore,
    onSuccess,
    onError,
    noDialog,
    noSave,
    refreshOn = [],
    ...rest
  } = options

  const query = useQuery<PaymentComplement[], any>(
    ['get-payment-complement-list', workspaceId, invoice, ...refreshOn],
    () => {
      if (!invoice || !invoice.idCfdi) throw new Error('CFDI cargado incorrectamente')
      onBefore && onBefore()
      return getPaymentComplementList(workspaceId, invoice.idCfdi)
    },
    {
      ...rest,
      onSuccess: data => {
        // !noSave && dispatch(setInvoicesList(data));
        onSuccess && onSuccess(data)
      },
      onError: async (error: any) => {
        const op = selectErrorDialog(error)
        if (op?.variant) {
          await dialog[op.variant](op)
          return
        }

        if (!noDialog) {
          const rp = await dialog.dangerAsync({
            title: 'generic.error.title',
            subtitle:
              'No se pudo obtener la lista de los complementos de pago para el CFDI seleccionado.',
            icon: ErrorOutline as TModalIcon,
            primaryButtonText: 'Reintentar',
            secondaryButtonText: 'Cancelar',
          })

          if (rp) {
            query.refetch()
            return
          }
        }

        onError && onError(error)
      },
    }
  )

  return query
}

export default usePaymentComplementList
